function isImageWithLink(image) {
    return (image.caption.startsWith('http') || image.caption.startsWith('/'))
        && image.caption.split(' ').length === 1;
}

export { isImageWithLink };
